<template>
<v-container >
  <v-row  >
    <v-col>
      <v-toolbar dense >
        <v-toolbar-title >
          <!-- <v-icon class='mr-2' color='amber' >mdi-wizard-hat</v-icon> -->
          Your AppointmentGuru Account
        </v-toolbar-title>
        <v-spacer/>
        <v-btn text small
          v-for="page in topLevelPages"
          :key="page.to"
          :to="page.to" >{{page.title}}</v-btn>
        <!-- <template slot="extension" >
          Guides:
          <v-btn text small outlined class="mx-2" >Get Setup</v-btn>
          <v-btn text small outlined class="mx-2" >Get Found</v-btn>
          <v-btn text small outlined class="mr-2" >Get more clients</v-btn>
          <v-btn text small outlined class="mr-2" >Get professional</v-btn>
          <v-btn text small outlined class="mr-2" >Get Paid</v-btn>
        </template> -->
      </v-toolbar>
    </v-col>
  </v-row>

  <v-row >
    <v-col cols=12 sm=4 >
      <v-card flat tile height='100%' style='border-right:solid 1px #ccc;' >
        <v-card-title class='subtitle-1 overline py-0 grey lighten-1' >
          Pick a guide
        </v-card-title>
        <v-divider/>
        <v-list class='pa-0'>
          <v-list-item-group :value="selectedGuide" color="primary" >
            <template v-for='wiz in wizards' >
              <v-list-item
                :to="`/guide/${wiz.id}`"
                :key='wiz.title' :value='wiz' >
                <v-list-item-avatar >
                  <v-icon>{{wiz.icon}}</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>{{wiz.title}}</v-list-item-title>
                  <v-list-item-subtitle>{{wiz.description}}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action >
                  <v-icon>mdi-chevron-right</v-icon>
                </v-list-item-action>
              </v-list-item>
              <v-divider :key='`div-${wiz.title}`' />
            </template>
          </v-list-item-group>
        </v-list>
      </v-card>
    </v-col>
    <v-col cols="12" sm="8">
      <component
        v-if='selectedGuide && selectedGuide.component'
        :is='selectedGuide.component' />
    </v-col>
  </v-row>

</v-container>
</template>

<script>
// import Todo from '@/views/Todo.vue'
import GetStartedGuide from '@/components/actions/guides/GetStartedGuide.vue'
import GetFound from '@/components/actions/guides/GetFound.vue'
// import Promote from '@/components/actions/guides/Promote.vue'
import Grow from '@/components/actions/guides/Grow.vue'
// import GetPaid from '@/components/actions/guides/GetPaid.vue'
// import InvoiceGuide from '@/components/actions/guides/InvoiceGuide.vue'
// import BuildBrandGuide from '@/components/actions/guides/BuildBrandGuide.vue'
// import FindAPro from '@/components/actions/guides/FindAPro/index.vue'
import {mapGetters} from 'vuex'

export default {
  name: 'Home',
  components: {
    // GetStartedGuide,
    // InvoiceGuide,
    // FindAPro
  },
  data () {
    return {
      touch: 0,
      wizards: [
        {
          id: 'configure',
          icon: 'mdi-cog',
          title: 'Configure your account',
          description: 'Make sure you have the bascs right',
          component: GetStartedGuide
        },
        {
          id: 'get-found',
          icon: 'mdi-map-marker-check-outline',
          title: 'Get found',
          description: 'Make sure your clients can easily find your appointments',
          component: GetFound
        },
        // {
        //   id: 'promote',
        //   icon: 'mdi-bullhorn',
        //   title: 'Promote your business',
        //   description: 'Claim your free websites, online bookings, sync the calendar to your phone',
        //   component: Promote
        // },
        // {
        //   id: 'get-paid',
        //   icon: 'mdi-currency-usd',
        //   title: 'Get paid',
        //   description: 'Make it easy for your clients to pay you with online payments',
        //   component: GetPaid
        // },
        {
          id: 'grow',
          icon: 'mdi-finance',
          title: 'Grow your business',
          description: 'Add spaces, colleagues receptionists and more',
          component: Grow
        }
        // {
        //   id: 'find-a-pro',
        //   icon: 'mdi-check-decagram',
        //   title: 'Find a pro',
        //   description: 'Find professionals to help you run your business',
        //   component: Todo
        // }
      ]
    }
  },
  computed: {
    ...mapGetters('identity', [
      'meProfile',
      'meInitials'
    ]),
    selectedGuide () {
      let gId = this.$route.params.guide
      let guide = this.wizards.find((wiz) => { return wiz.id === gId })
      if (!guide) { return this.wizards[0] }
      return guide
    }
  }
}
</script>
